var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetTokens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37484 4.16666C4.77067 4.16666 1.0415 7.89582 1.0415 12.5C1.0415 17.1042 4.77067 20.8333 9.37484 20.8333C13.979 20.8333 17.7082 17.1042 17.7082 12.5C17.7082 7.89582 13.979 4.16666 9.37484 4.16666ZM9.37484 18.75C5.92692 18.75 3.12484 15.9479 3.12484 12.5C3.12484 9.05207 5.92692 6.24999 9.37484 6.24999C12.8228 6.24999 15.6248 9.05207 15.6248 12.5C15.6248 15.9479 12.8228 18.75 9.37484 18.75ZM12.4998 10.9375H10.4165V16.1458H8.33317V10.9375H6.24984V9.37499H12.4998V10.9375ZM21.0936 3.90624L23.9582 5.20832L21.0936 6.51041L19.7915 9.37499L18.4894 6.51041L15.6248 5.20832L18.4894 3.90624L19.7915 1.04166L21.0936 3.90624ZM21.0936 18.4896L23.9582 19.7917L21.0936 21.0937L19.7915 23.9583L18.4894 21.0937L15.6248 19.7917L18.4894 18.4896L19.7915 15.625L21.0936 18.4896Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetTokens);
export default __webpack_public_path__ + "static/media/getTokens.202d8b8b71470d5fdec62e77dd4890b5.svg";
export { ForwardRef as ReactComponent };